namespace app.support.authorization {

    import IPermission = app.autenticacao.IPermission;

    export class AuthorizationService {

        /** @ngInject */
        constructor(private authService: app.autenticacao.AuthService) {

        }
        
        findPermission(idRecurso: string, context: string, readOnly = true): ng.IPromise<app.autenticacao.IPermission> {
            return this.userComponents().then(
                (componentes) => componentes.find(p => this.comparePermission(p, context, [idRecurso], readOnly))
            );
        }

        /**
         * Cria um gerenciador de permissões para o contexto especificado e para as permissões especificadas.
         * Caso nenhuma permissão seja especificada, retorna um gerenciador de permissões para todas as permissões
         * do contexto especificado.
         * 
         * @param context 
         * @param idsRecursos 
         * @returns 
         */
        permissionManager(context: string, ...idsRecursos: string[]): ng.IPromise<PermissionManager> {
            return this.userComponents().then(
                (componentes) => new PermissionManager(
                    context,
                    componentes.filter(p => this.comparePermission(p, context, idsRecursos)))
            );
        }

        /**
         * Verifica se uma permissão especificada está presente na lista de permissões alvo e
         * pertence ao contexto alvo.
         * 
         * @param permission 
         * @param targetContext 
         * @param targetIdRecursos Se for vazio, verificará apenas se a permissão pertence ao contexto
         * @returns 
         */
        private comparePermission(permission: IPermission, targetContext: string, targetIdRecursos: string[], readOnly = true) {
            return permission.context === targetContext && 
                (targetIdRecursos.length === 0 || targetIdRecursos.indexOf(permission.id) !== -1) &&
                (readOnly || permission.readOnly === readOnly);
        }

        private userComponents(): ng.IPromise<IPermission[]> {
            return this.authService.getUser().then(user => user.componentes);
        }

    }

    angular
        .module('app.support.authorization')
        .service('authorizationService', AuthorizationService);

}